import { useContext } from "react";
import "./currentOrders.styles.scss";
import { OrdersContext } from "../../../../contexts/orders.context";
const CurrentOrders = () => {
  const { tableSideOrders, takeawayOrders } = useContext(OrdersContext);
  return (
    <div className="current-orders-container">
      <div className="current-orders-tableside">
        <span className="current-orders-title">TABLESIDE</span>
        <div className="current-orders-inner-container">
          {Object.keys(tableSideOrders).map((index) => {
            const tempObject = tableSideOrders[index];
            return (
              <div key={index} className="current-order-tableside">
                <span className="current-order-tablenumber">
                  <span className="current-order-tag">
                    Table No&nbsp;:&nbsp;
                  </span>
                  {tempObject["tableNumber"]}
                </span>
                <span className="current-order-status">
                  <span className="current-order-tag">Status&nbsp;:&nbsp;</span>
                  {tempObject["status"]}
                </span>
                <span className="current-order-total">
                  <span className="current-order-tag">Total&nbsp;:&nbsp;</span>
                  {tempObject["orderTotal"]}
                </span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="current-orders-takeaway">
        <span className="current-orders-title">TAKEAWAY</span>
        <div className="current-orders-inner-container">
          {Object.keys(takeawayOrders).map((index) => {
            const tempObject = takeawayOrders[index];
            return (
              <div key={index} className="current-order-takeaway">
                <span className="current-order-ordernumber">
                  <span className="current-order-tag">
                    Order No&nbsp;:&nbsp;
                  </span>
                  {index}
                </span>
                <span className="current-order-status">
                  <span className="current-order-tag">Status&nbsp;:&nbsp;</span>
                  {tempObject["status"]}
                </span>
                <span className="current-order-total">
                  <span className="current-order-tag">Total&nbsp;:&nbsp;</span>
                  {tempObject["orderTotal"]}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default CurrentOrders;
